import {
  Box,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import DoneIcon from "@mui/icons-material/Done";
import axios from "axios";
import { toast } from "react-toastify";

import { APIUrlThree, APIUrlToken } from "../../Utils/Utils";

import sidearrowmobile from "../../Assets/sidearrowmobile.svg";
import locationfiltermobile from "../../Assets/locationfiltermobile.svg";
import regulationfiltermobile from "../../Assets/industryfiltermobile.svg";
import statusfiltermobile from "../../Assets/revenuefiltermobile.svg";
import datefiltermobile from "../../Assets/joiscorefiltermobile.svg";

const LegislativeFiltersMobile = ({
  openFilterDrawer,
  setOpenFilterDrawer,
  openFilterDetail,
  setOpenFilterDetail,

  stateSelectedData,
  setStateSelectedData,

  regulationChangeSelectedData,
  setRegulationChangeSelectedData,

  statusSelectedData,
  setStatusSelectedData,

  dateRangeSelectedData,
  setDateRangeSelectedData,

  handleApply,
  ResetFilterData,
  isTabPortrait,
}) => {
  /* -------------------- DATA -------------------- */

  const regulationTypeDataList = [
    "legislation",
    "regulation",
    "ballot measure",
    "executive order",
    "agency document",
  ];

  const stateDataList = [
    "United States",
    "Competitive States",
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  const competitiveStatesList = [
    "Arizona",
    "California",
    "Florida",
    "Georgia",
    "Illinois",
    "Indiana",
    "Kentucky",
    "Michigan",
    "New York",
    "North Carolina",
    "Pennsylvania",
    "South Carolina",
    "Tennessee",
    "Texas",
    "Virginia",
    "West Virginia",
    "Wisconsin",
  ];

  const dateRangeDataList = ["year-to-date", "30-days", "90-days"];

  const [statusDataList, setStatusDataList] = React.useState([]);

  const isStatusDisabled = regulationChangeSelectedData.length !== 1;

  /* -------------------- STATE TOGGLE -------------------- */

  const handleStateToggle = (item) => {
    if (stateSelectedData.includes(item)) {
      if (item === "Competitive States") {
        const filtered = stateSelectedData.filter(
          (s) =>
            s !== "Competitive States" && !competitiveStatesList.includes(s),
        );
        setStateSelectedData(filtered);
      } else {
        setStateSelectedData(stateSelectedData.filter((s) => s !== item));
      }
    } else {
      if (item === "Competitive States") {
        const updated = Array.from(
          new Set([...stateSelectedData, item, ...competitiveStatesList]),
        );
        setStateSelectedData(updated);
      } else {
        setStateSelectedData([...stateSelectedData, item]);
      }
    }
  };

  /* -------------------- MEASURE TYPE -------------------- */

  const handleMeasureToggle = (item) => {
    if (regulationChangeSelectedData.includes(item)) {
      setRegulationChangeSelectedData(
        regulationChangeSelectedData.filter((i) => i !== item),
      );
    } else {
      setRegulationChangeSelectedData([...regulationChangeSelectedData, item]);
    }
  };

  /* -------------------- STATUS API -------------------- */

  const getOneStatusList = async (item) => {
    const name =
      item === "legislation"
        ? "legtrack"
        : item === "regulation"
          ? "regtrack"
          : item === "ballot measure"
            ? "ballot_measure"
            : item === "executive order"
              ? "exec_order"
              : item === "agency document"
                ? "rdoc"
                : null;

    if (!name) return [];

    try {
      const response = await axios({
        method: "POST",
        headers: {
          "content-type": "application/json",
          "X-API-Key": APIUrlToken(),
        },
        url: `${APIUrlThree()}/v1/get_status_types?document_name=${name}`,
      });

      const data = response?.data;

      if (Array.isArray(data)) return data;
      if (Array.isArray(data?.data)) return data.data;

      return [];
    } catch {
      toast.error("Failed to fetch status list");
      return [];
    }
  };

  React.useEffect(() => {
    const fetchStatuses = async () => {
      if (isStatusDisabled) {
        setStatusSelectedData([]);
        setStatusDataList([]);
        return;
      }

      const result = await getOneStatusList(regulationChangeSelectedData[0]);
      setStatusDataList(result);
    };

    fetchStatuses();
  }, [regulationChangeSelectedData]);

  /* -------------------- STATUS TOGGLE -------------------- */

  const handleStatusToggle = (item) => {
    if (statusSelectedData.includes(item)) {
      setStatusSelectedData(statusSelectedData.filter((i) => i !== item));
    } else {
      setStatusSelectedData([...statusSelectedData, item]);
    }
  };

  /* -------------------- DATE RANGE -------------------- */

  const handleDateToggle = (item) => {
    setDateRangeSelectedData([item]);
  };

  /* -------------------- UI -------------------- */

  return (
    <Slide direction="left" in={openFilterDrawer} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: "fixed",
          top: isTabPortrait ? "33px" : 0,
          right: 0,
          width: isTabPortrait ? "calc(100vw - 240px)" : "100vw",
          height: "100vh",
          bgcolor: "#fff",
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          margin: "56px 0px 90px 0px",
          pb: 20,

          // margin: "60px 0px 90px 0px"
        }}
      >
        {/* HEADER */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          p={2}
        >
          <IconButton
            onClick={() =>
              openFilterDetail
                ? setOpenFilterDetail("")
                : setOpenFilterDrawer(false)
            }
          >
            <ArrowBackIosNewIcon fontSize="small" />
          </IconButton>

          <Typography fontWeight="bold">
            {openFilterDetail || "Filters"}
          </Typography>

          <Button
            sx={{ textTransform: "none", color: "#0004FF" }}
            onClick={() => {
              ResetFilterData();
              setOpenFilterDetail("");
              setOpenFilterDrawer(false);
            }}
          >
            Clear All
          </Button>
        </Box>

        <Divider />

        {/* DETAIL VIEW */}
        {openFilterDetail === "State" && (
          <List sx={{ pb: "90px", mb: "10px", overflowY: "auto" }}>
            {stateDataList.map((item) => {
              const isSelected = stateSelectedData.includes(item);

              return (
                <ListItem
                  key={item}
                  disablePadding
                  onClick={() => handleStateToggle(item)}
                  sx={{
                    bgcolor: isSelected ? "#4da6ff" : "#fff",
                    color: isSelected ? "#fff" : "#000",
                    borderRadius: 1,
                    mb: 1,
                  }}
                >
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      textTransform: "capitalize",
                      color: "inherit",
                    }}
                    sx={{ px: 2 }}
                  />
                </ListItem>
              );
            })}
          </List>
        )}
        {openFilterDetail === "Measure Type" && (
          <List sx={{ pb: "90px", mb: "10px", overflowY: "auto" }}>
            {regulationTypeDataList.map((item) => {
              const isSelected = regulationChangeSelectedData.includes(item);

              return (
                <ListItem
                  key={item}
                  disablePadding
                  onClick={() => handleMeasureToggle(item)}
                  sx={{
                    bgcolor: isSelected ? "#4da6ff" : "#fff",
                    color: isSelected ? "#fff" : "#000",
                    borderRadius: 1,
                    mb: 1,
                  }}
                >
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      textTransform: "capitalize",
                      color: "inherit",
                    }}
                    sx={{ px: 2 }}
                  />
                </ListItem>
              );
            })}
          </List>
        )}
        {openFilterDetail === "Status" && (
          <List sx={{ pb: "90px", mb: "10px", overflowY: "auto" }}>
            {Array.isArray(statusDataList) &&
              statusDataList.map((item) => {
                const isSelected = statusSelectedData.includes(item);

                return (
                  <ListItem
                    key={item}
                    disablePadding
                    onClick={() => handleStatusToggle(item)}
                    sx={{
                      bgcolor: isSelected ? "#4da6ff" : "#fff",
                      color: isSelected ? "#fff" : "#000",
                      borderRadius: 1,
                      mb: 1,
                    }}
                  >
                    <ListItemText
                      primary={item}
                      primaryTypographyProps={{
                        textTransform: "capitalize",
                        color: "inherit",
                      }}
                      sx={{ px: 2 }}
                    />
                  </ListItem>
                );
              })}
          </List>
        )}
        {openFilterDetail === "Date Range" && (
          <List sx={{ pb: "90px", mb: "10px", overflowY: "auto" }}>
            {dateRangeDataList.map((item) => {
              const isSelected = dateRangeSelectedData.includes(item);

              return (
                <ListItem
                  key={item}
                  disablePadding
                  onClick={() => handleDateToggle(item)}
                  sx={{
                    bgcolor: isSelected ? "#4da6ff" : "#fff",
                    color: isSelected ? "#fff" : "#000",
                    borderRadius: 1,
                    mb: 1,
                  }}
                >
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      textTransform: "capitalize",
                      color: "inherit",
                    }}
                    sx={{ px: 2 }}
                  />
                </ListItem>
              );
            })}
          </List>
        )}

        {openFilterDetail ? (
          <List sx={{ pb: "90px", mb: "10px" }} style={{ overflowY: "auto" }}>
            {/* {(openFilterDetail === "State"
                            ? stateDataList
                            : openFilterDetail === "Measure Type"
                                ? regulationTypeDataList
                                : openFilterDetail === "Status"
                                    ? statusDataList
                                    : dateRangeDataList
                        ).map((item) => {
                            const isSelected =
                                openFilterDetail === "State"
                                    ? stateSelectedData.includes(item)
                                    : openFilterDetail === "Measure Type"
                                        ? regulationChangeSelectedData.includes(item)
                                        : openFilterDetail === "Status"
                                            ? statusSelectedData.includes(item)
                                            : dateRangeSelectedData.includes(item);

                            return (
                                <ListItem
                                    key={item}
                                    button
                                    onClick={() => {
                                        if (openFilterDetail === "State") handleStateToggle(item);
                                        else if (openFilterDetail === "Measure Type") handleMeasureToggle(item);
                                        else if (openFilterDetail === "Status") handleStatusToggle(item);
                                        else handleDateToggle(item);
                                    }}
                                    sx={{
                                        bgcolor: isSelected ? "#4da6ff" : "#fff",
                                        color: isSelected ? "#fff" : "#000",
                                        borderRadius: 1,
                                        py: 0,
                                        mb: 1,
                                    }}
                                >
                                    <ListItemText primary={item} sx={{
                                        textTransform: "capitalize"
                                    }} />
                                </ListItem>
                            );
                        })} */}
          </List>
        ) : (
          /* MAIN FILTER LIST */
          <List>
            {[
              {
                label: "State",
                icon: locationfiltermobile,
                count: stateSelectedData.length,
              },
              {
                label: "Measure Type",
                icon: regulationfiltermobile,
                count: regulationChangeSelectedData.length,
              },
              {
                label: "Status",
                icon: statusfiltermobile,
                count: statusSelectedData.length,
                disabled: isStatusDisabled,
              },
              {
                label: "Date Range",
                icon: datefiltermobile,
                count: dateRangeSelectedData.length,
              },
            ].map(({ label, icon, count, disabled }) => (
              <ListItem
                key={label}
                button
                divider
                disabled={disabled}
                onClick={() => !disabled && setOpenFilterDetail(label)}
                secondaryAction={
                  <Box display="flex" alignItems="center" gap={1}>
                    {count > 0 && <Typography>{count} Selected</Typography>}
                    {!disabled && <img src={sidearrowmobile} alt="" />}
                  </Box>
                }
                sx={{
                  opacity: disabled ? 0.5 : 1,
                }}
              >
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <img src={icon} alt="" />
                </ListItemIcon>
                <ListItemText primary={label} />
              </ListItem>
            ))}
          </List>
        )}

        {/* APPLY */}
        {!openFilterDetail && (
          <Box p={2}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="flex-end"
              sx={{ px: 2 }}
            >
              {/* Reset */}
              <Button
                variant="text"
                onClick={() => {
                  ResetFilterData();
                  setOpenFilterDetail("");
                  setOpenFilterDrawer(false);
                }}
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                  color: "#555",
                  "&:hover": {
                    backgroundColor: "transparent",
                    textDecoration: "underline",
                  },
                }}
              >
                Reset
              </Button>

              {/* Apply */}
              <Button
                variant="contained"
                onClick={() => {
                  handleApply();
                  setOpenFilterDetail("");
                  setOpenFilterDrawer(false);
                }}
                sx={{
                  backgroundColor: "#D32F2F",
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 1,
                  px: 3,
                  "&:hover": {
                    backgroundColor: "#B71C1C",
                  },
                }}
              >
                Apply
              </Button>
            </Stack>
          </Box>
        )}
      </Box>
    </Slide>
  );
};

export default LegislativeFiltersMobile;

// import {
//     Box,
//     Button,
//     Divider,
//     IconButton,
//     List,
//     ListItem,
//     ListItemIcon,
//     ListItemText,
//     Slide,
//     Stack,
//     Typography,
// } from "@mui/material";
// import React from "react";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import DoneIcon from "@mui/icons-material/Done";
// import axios from "axios";
// import { toast } from "react-toastify";

// import { APIUrlThree, APIUrlToken } from "../../Utils/Utils";

// import sidearrowmobile from "../../Assets/sidearrowmobile.svg";
// import locationfiltermobile from "../../Assets/locationfiltermobile.svg";
// import regulationfiltermobile from "../../Assets/industryfiltermobile.svg";
// import statusfiltermobile from "../../Assets/revenuefiltermobile.svg";
// import datefiltermobile from "../../Assets/joiscorefiltermobile.svg";

// const LegislativeFiltersMobile = ({
//     openFilterDrawer,
//     setOpenFilterDrawer,
//     openFilterDetail,
//     setOpenFilterDetail,

//     stateSelectedData,
//     setStateSelectedData,

//     regulationChangeSelectedData,
//     setRegulationChangeSelectedData,

//     statusSelectedData,
//     setStatusSelectedData,

//     dateRangeSelectedData,
//     setDateRangeSelectedData,

//     handleApply,
//     ResetFilterData,
//     isTabPortrait,
// }) => {
//     /* -------------------- DATA -------------------- */

//     const regulationTypeDataList = [
//         "legislation",
//         "regulation",
//         "ballot measure",
//         "executive order",
//         "agency document",
//     ];

//     const stateDataList = [
//         "United States",
//         "Competitive States",
//         "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
//         "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho",
//         "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine",
//         "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",
//         "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
//         "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
//         "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
//         "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia",
//         "Washington", "West Virginia", "Wisconsin", "Wyoming",
//     ];

//     const competitiveStatesList = [
//         "Arizona", "California", "Florida", "Georgia", "Illinois", "Indiana",
//         "Kentucky", "Michigan", "New York", "North Carolina", "Pennsylvania",
//         "South Carolina", "Tennessee", "Texas", "Virginia", "West Virginia", "Wisconsin",
//     ];

//     const dateRangeDataList = ["year-to-date", "30-days", "90-days"];

//     const [statusDataList, setStatusDataList] = React.useState([]);

//     const isStatusDisabled =
//         regulationChangeSelectedData.length !== 1;

//     /* -------------------- STATE TOGGLE -------------------- */

//     const handleStateToggle = (item) => {
//         if (stateSelectedData.includes(item)) {
//             if (item === "Competitive States") {
//                 const filtered = stateSelectedData.filter(
//                     (s) => s !== "Competitive States" && !competitiveStatesList.includes(s)
//                 );
//                 setStateSelectedData(filtered);
//             } else {
//                 setStateSelectedData(stateSelectedData.filter((s) => s !== item));
//             }
//         } else {
//             if (item === "Competitive States") {
//                 const updated = Array.from(
//                     new Set([...stateSelectedData, item, ...competitiveStatesList])
//                 );
//                 setStateSelectedData(updated);
//             } else {
//                 setStateSelectedData([...stateSelectedData, item]);
//             }
//         }
//     };

//     /* -------------------- MEASURE TYPE -------------------- */

//     const handleMeasureToggle = (item) => {
//         if (regulationChangeSelectedData.includes(item)) {
//             setRegulationChangeSelectedData(
//                 regulationChangeSelectedData.filter((i) => i !== item)
//             );
//         } else {
//             setRegulationChangeSelectedData([...regulationChangeSelectedData, item]);
//         }
//     };

//     /* -------------------- STATUS API -------------------- */

//     const getOneStatusList = async (item) => {
//         const name =
//             item === "legislation" ? "legtrack" :
//                 item === "regulation" ? "regtrack" :
//                     item === "ballot measure" ? "ballot_measure" :
//                         item === "executive order" ? "exec_order" :
//                             item === "agency document" ? "rdoc" :
//                                 null;

//         if (!name) return [];

//         try {
//             const response = await axios({
//                 method: "POST",
//                 headers: {
//                     "content-type": "application/json",
//                     "X-API-Key": APIUrlToken(),
//                 },
//                 url: `${APIUrlThree()}/v1/get_status_types?document_name=${name}`,
//             });
//             return response?.data || [];
//         } catch {
//             toast.error("Failed to fetch status list");
//             return [];
//         }
//     };

//     React.useEffect(() => {
//         const fetchStatuses = async () => {
//             if (isStatusDisabled) {
//                 setStatusSelectedData([]);
//                 setStatusDataList([]);
//                 return;
//             }

//             const result = await getOneStatusList(regulationChangeSelectedData[0]);
//             setStatusDataList(result);
//         };

//         fetchStatuses();
//     }, [regulationChangeSelectedData]);

//     /* -------------------- STATUS TOGGLE -------------------- */

//     const handleStatusToggle = (item) => {
//         if (statusSelectedData.includes(item)) {
//             setStatusSelectedData(statusSelectedData.filter((i) => i !== item));
//         } else {
//             setStatusSelectedData([...statusSelectedData, item]);
//         }
//     };

//     /* -------------------- DATE RANGE -------------------- */

//     const handleDateToggle = (item) => {
//         setDateRangeSelectedData([item]);
//     };

//     /* -------------------- UI -------------------- */

//     return (
//         <Slide direction="left" in={openFilterDrawer} mountOnEnter unmountOnExit>
//             <Box
//                 sx={{
//                     position: "fixed",
//                     top: isTabPortrait ? "33px" : 0,
//                     right: 0,
//                     width: isTabPortrait ? "calc(100vw - 240px)" : "100vw",
//                     height: "100vh",
//                     bgcolor: "#fff",
//                     zIndex: 10,
//                     display: "flex",
//                     flexDirection: "column",
//                     margin: "56px 0px 90px 0px"
//                     // margin: "60px 0px 90px 0px"
//                 }}
//             >
//                 {/* HEADER */}
//                 <Box display="flex" alignItems="center" justifyContent="space-between" p={2}>
//                     <IconButton
//                         onClick={() =>
//                             openFilterDetail ? setOpenFilterDetail("") : setOpenFilterDrawer(false)
//                         }
//                     >
//                         <ArrowBackIosNewIcon fontSize="small" />
//                     </IconButton>

//                     <Typography fontWeight="bold">
//                         {openFilterDetail || "Filters"}
//                     </Typography>

//                     <Button
//                         sx={{ textTransform: "none", color: "#0004FF" }}
//                         onClick={() => {
//                             ResetFilterData();
//                             setOpenFilterDetail("");
//                             setOpenFilterDrawer(false);
//                         }}
//                     >
//                         Clear All
//                     </Button>
//                 </Box>

//                 <Divider />

//                 {/* DETAIL VIEW */}
//                 {openFilterDetail === "State" && (
//                     <List sx={{ pb: "90px", mb: "10px", overflowY: "auto" }}>
//                         {stateDataList.map((item) => {
//                             const isSelected = stateSelectedData.includes(item);

//                             return (
//                                 <ListItem
//                                     key={item}
//                                     disablePadding
//                                     onClick={() => handleStateToggle(item)}
//                                     sx={{
//                                         bgcolor: isSelected ? "#4da6ff" : "#fff",
//                                         color: isSelected ? "#fff" : "#000",
//                                         borderRadius: 1,
//                                         mb: 1,
//                                     }}
//                                 >
//                                     <ListItemText
//                                         primary={item}
//                                         primaryTypographyProps={{
//                                             textTransform: "capitalize",
//                                             color: "inherit",
//                                         }}
//                                         sx={{ px: 2 }}
//                                     />
//                                 </ListItem>
//                             );
//                         })}
//                     </List>
//                 )}
//                 {openFilterDetail === "Measure Type" && (
//                     <List sx={{ pb: "90px", mb: "10px", overflowY: "auto" }}>
//                         {regulationTypeDataList.map((item) => {
//                             const isSelected = regulationChangeSelectedData.includes(item);

//                             return (
//                                 <ListItem
//                                     key={item}
//                                     disablePadding
//                                     onClick={() => handleMeasureToggle(item)}
//                                     sx={{
//                                         bgcolor: isSelected ? "#4da6ff" : "#fff",
//                                         color: isSelected ? "#fff" : "#000",
//                                         borderRadius: 1,
//                                         mb: 1,
//                                     }}
//                                 >
//                                     <ListItemText
//                                         primary={item}
//                                         primaryTypographyProps={{
//                                             textTransform: "capitalize",
//                                             color: "inherit",
//                                         }}
//                                         sx={{ px: 2 }}
//                                     />
//                                 </ListItem>
//                             );
//                         })}
//                     </List>
//                 )}
//                 {openFilterDetail === "Status" && (
//                     <List sx={{ pb: "90px", mb: "10px", overflowY: "auto" }}>
//                         {statusDataList.map((item) => {
//                             const isSelected = statusSelectedData.includes(item);

//                             return (
//                                 <ListItem
//                                     key={item}
//                                     disablePadding
//                                     onClick={() => handleStatusToggle(item)}
//                                     sx={{
//                                         bgcolor: isSelected ? "#4da6ff" : "#fff",
//                                         color: isSelected ? "#fff" : "#000",
//                                         borderRadius: 1,
//                                         mb: 1,
//                                     }}
//                                 >
//                                     <ListItemText
//                                         primary={item}
//                                         primaryTypographyProps={{
//                                             textTransform: "capitalize",
//                                             color: "inherit",
//                                         }}
//                                         sx={{ px: 2 }}
//                                     />
//                                 </ListItem>
//                             );
//                         })}
//                     </List>
//                 )}
//                 {openFilterDetail === "Date Range" && (
//                     <List sx={{ pb: "90px", mb: "10px", overflowY: "auto" }}>
//                         {dateRangeDataList.map((item) => {
//                             const isSelected = dateRangeSelectedData.includes(item);

//                             return (
//                                 <ListItem
//                                     key={item}
//                                     disablePadding
//                                     onClick={() => handleDateToggle(item)}
//                                     sx={{
//                                         bgcolor: isSelected ? "#4da6ff" : "#fff",
//                                         color: isSelected ? "#fff" : "#000",
//                                         borderRadius: 1,
//                                         mb: 1,
//                                     }}
//                                 >
//                                     <ListItemText
//                                         primary={item}
//                                         primaryTypographyProps={{
//                                             textTransform: "capitalize",
//                                             color: "inherit",
//                                         }}
//                                         sx={{ px: 2 }}
//                                     />
//                                 </ListItem>
//                             );
//                         })}
//                     </List>
//                 )}

//                 {openFilterDetail ? (
//                     <List sx={{ pb: "90px", mb: "10px" }} style={{ overflowY: "auto" }}>
//                         {/* {(openFilterDetail === "State"
//                             ? stateDataList
//                             : openFilterDetail === "Measure Type"
//                                 ? regulationTypeDataList
//                                 : openFilterDetail === "Status"
//                                     ? statusDataList
//                                     : dateRangeDataList
//                         ).map((item) => {
//                             const isSelected =
//                                 openFilterDetail === "State"
//                                     ? stateSelectedData.includes(item)
//                                     : openFilterDetail === "Measure Type"
//                                         ? regulationChangeSelectedData.includes(item)
//                                         : openFilterDetail === "Status"
//                                             ? statusSelectedData.includes(item)
//                                             : dateRangeSelectedData.includes(item);

//                             return (
//                                 <ListItem
//                                     key={item}
//                                     button
//                                     onClick={() => {
//                                         if (openFilterDetail === "State") handleStateToggle(item);
//                                         else if (openFilterDetail === "Measure Type") handleMeasureToggle(item);
//                                         else if (openFilterDetail === "Status") handleStatusToggle(item);
//                                         else handleDateToggle(item);
//                                     }}
//                                     sx={{
//                                         bgcolor: isSelected ? "#4da6ff" : "#fff",
//                                         color: isSelected ? "#fff" : "#000",
//                                         borderRadius: 1,
//                                         py: 0,
//                                         mb: 1,
//                                     }}
//                                 >
//                                     <ListItemText primary={item} sx={{
//                                         textTransform: "capitalize"
//                                     }} />
//                                 </ListItem>
//                             );
//                         })} */}
//                     </List>
//                 ) : (
//                     /* MAIN FILTER LIST */
//                     <List>
//                         {[
//                             { label: "State", icon: locationfiltermobile, count: stateSelectedData.length },
//                             { label: "Measure Type", icon: regulationfiltermobile, count: regulationChangeSelectedData.length },
//                             {
//                                 label: "Status",
//                                 icon: statusfiltermobile,
//                                 count: statusSelectedData.length,
//                                 disabled: isStatusDisabled,
//                             },
//                             { label: "Date Range", icon: datefiltermobile, count: dateRangeSelectedData.length },
//                         ].map(({ label, icon, count, disabled }) => (
//                             <ListItem
//                                 key={label}
//                                 button
//                                 divider
//                                 disabled={disabled}
//                                 onClick={() => !disabled && setOpenFilterDetail(label)}
//                                 secondaryAction={
//                                     <Box display="flex" alignItems="center" gap={1}>
//                                         {count > 0 && <Typography>{count} Selected</Typography>}
//                                         {!disabled && <img src={sidearrowmobile} alt="" />}
//                                     </Box>
//                                 }
//                                 sx={{
//                                     opacity: disabled ? 0.5 : 1,
//                                 }}
//                             >
//                                 <ListItemIcon sx={{ minWidth: 32 }}>
//                                     <img src={icon} alt="" />
//                                 </ListItemIcon>
//                                 <ListItemText primary={label} />
//                             </ListItem>
//                         ))}
//                     </List>
//                 )}

//                 {/* APPLY */}
//                 {!openFilterDetail && (
//                     <Box p={2}>
//                         <Stack
//                             direction="row"
//                             spacing={2}
//                             alignItems="center"
//                             justifyContent="flex-end"
//                             sx={{ px: 2 }}
//                         >
//                             {/* Reset */}
//                             <Button
//                                 variant="text"
//                                 onClick={() => {
//                                     ResetFilterData(); setOpenFilterDetail("");
//                                     setOpenFilterDrawer(false);
//                                 }}
//                                 sx={{
//                                     textTransform: "none",
//                                     fontWeight: 500,
//                                     color: "#555",
//                                     "&:hover": {
//                                         backgroundColor: "transparent",
//                                         textDecoration: "underline",
//                                     },
//                                 }}
//                             >
//                                 Reset
//                             </Button>

//                             {/* Apply */}
//                             <Button
//                                 variant="contained"
//                                 onClick={() => {
//                                     handleApply(); setOpenFilterDetail("");
//                                     setOpenFilterDrawer(false);
//                                 }}
//                                 sx={{
//                                     backgroundColor: "#D32F2F",
//                                     textTransform: "none",
//                                     fontWeight: 600,
//                                     borderRadius: 1,
//                                     px: 3,
//                                     "&:hover": {
//                                         backgroundColor: "#B71C1C",
//                                     },
//                                 }}
//                             >
//                                 Apply
//                             </Button>
//                         </Stack>
//                     </Box>
//                 )}
//             </Box>
//         </Slide>
//     );
// };

// export default LegislativeFiltersMobile;
